import { Controller } from "@hotwired/stimulus"
import { i18n } from "../lib/i18n"

/**
 * Updates the Any/All explanation text when toggling match mode on a
 * multi-checkbox filter. Chip selected state is handled entirely via
 * the CSS `has-[:checked]` selector.
 *
 * Connects to data-controller="checkbox-filter"
 */
export default class extends Controller {
  static targets = ["match", "explanation"]

  declare readonly matchTargets: HTMLInputElement[]
  declare readonly explanationTarget: HTMLElement
  declare readonly hasExplanationTarget: boolean

  connect() {
    this.updateExplanation()
  }

  updateExplanation() {
    if (!this.hasExplanationTarget) return

    const checked = this.matchTargets.find((radio) => radio.checked)
    if (!checked) return

    this.explanationTarget.textContent =
      checked.value === "all"
        ? i18n.t("checkbox_filter.explanation_all")
        : i18n.t("checkbox_filter.explanation_any")
  }
}
